import React from "react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Table, Column } from "@tanstack/react-table";
import { ButtonOutline } from "./ButtonOutline";
import { GitPullRequestDraft } from "lucide-react";

export default function RowSelectorButton<TData>({
  table,
}: {
  table: Table<TData>;
}) {
  const tableVisbility = async (column: Column<TData>) => {
    const isVisible = column.getIsVisible();
    column.toggleVisibility(!isVisible);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <ButtonOutline className="w-[50px]">
          <GitPullRequestDraft className="w-6 h-6" />
        </ButtonOutline>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card text-foreground">
        {table
          .getAllColumns()
          .filter((column) => column.getCanHide())
          .map((column) => {
            return (
              <DropdownMenuCheckboxItem
                key={column.id}
                className="capitalize"
                checked={column.getIsVisible()}
                onCheckedChange={() => {
                  tableVisbility(column);
                }}
              >
                {column.id}
              </DropdownMenuCheckboxItem>
            );
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
